import classes from './Footer.module.css';
import { FaInstagram, FaTwitter } from 'react-icons/fa';
import { GrFacebook, GrSkype } from 'react-icons/gr';

function Footer() {
  return (
    <>
      <div
        className="container-fluid p-2 text-center"
        // style={{ backgroundColor: "#7e56d8" }}
      >
        <div className={"footer text-right " + classes.footerContainer}>
          <div className="container">
            <div className={classes.footerFlexContainer}>
              <div style={{ color: "white" }}>
                <span>© {new Date().getFullYear()} Seeding Brains</span>
              </div>
              <div className={classes.footerIcons}>
                <a href="https://www.facebook.com" target="_blank">
                  <GrFacebook size={30} />
                </a>
                <a href="https://www.instagram.com" target="_blank">
                  <FaInstagram size={30} />
                </a>
                <a href="https://www.skype.com">
                  <GrSkype size={30} />
                </a>
                <a href="https://www.twitter.com">
                  <FaTwitter size={30} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
